export enum CurrencyInputDisplay {
  CODE = 'code',
  SYMBOL = 'symbol',
  SYMBOLNARROW = 'symbol-narrow'
}
